import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Icon from './Icon';
import { about } from '../mock/mock';

export default function AboutPreview() {
  return (
    <section className="relative max-w-7xl mx-auto px-5 md:px-8 section-pad">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div className="reveal relative">
          <div className="absolute -inset-4 bg-[#2563eb]/10 blur-3xl rounded-full" aria-hidden />
          <img
            src="https://images.unsplash.com/photo-1676277758484-908057468cca?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
            alt="Interscope performance marketing team"
            className="relative rounded-3xl border border-slate-200 object-cover w-full h-[420px]"
            loading="lazy"
          />
        </div>
        <div className="reveal">
          <span className="inline-block mb-3 text-xs font-semibold tracking-[0.25em] uppercase text-[#2563eb]">About Interscope</span>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-slate-900 leading-tight">
            A global, data-driven <span className="text-gradient">growth partner.</span>
          </h2>
          <p className="mt-4 text-slate-600 leading-relaxed">{about.intro}</p>
          <div className="mt-6 grid sm:grid-cols-2 gap-4">
            {about.points.map((p) => (
              <div key={p.title} className="rounded-2xl border border-slate-200 bg-slate-50 p-5">
                <div className="w-10 h-10 rounded-xl bg-[#2563eb]/12 grid place-items-center text-[#2563eb] mb-3"><Icon name={p.icon} size={20} /></div>
                <h3 className="font-display text-sm font-semibold text-slate-900">{p.title}</h3>
                <p className="text-xs text-slate-500 mt-1 leading-relaxed">{p.desc}</p>
              </div>
            ))}
          </div>
          <Link to="/about" className="mt-7 inline-flex items-center gap-2 text-sm font-semibold text-[#2563eb] hover:gap-3 transition-all">
            More about us <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
}
